module.exports = __webpack_public_path__ + "static/media/BlockchainBg.86f0998d.png";